<template>
    <tabs nav-style="tabs" v-model="activeTabIndex">
        <tab header="PA">
            <h3>PA</h3>
            <div class="wrapper">
                <loader v-if="loading" />
                <form v-if="!loading" class="form form-horizontal" @submit.prevent data-vv-scope="pa">
                    <div class="form-group">
                        <label class="col-md-2 control-label">DB Number</label>
                        <div class="col-md-9" style="margin-top: 10px;">{{ pa.dbnumber}}</div>
                    </div>
                    <div class="form-group" v-bind:class="{ 'has-error': errors.has('pa.paName') }">
                        <label class="col-md-2 control-label">PA Name</label>
                        <div class="col-md-9">
                            <input v-model="pa.paName" v-validate="'required|max:255'" class="form-control" type="text"
                                name="paName" aria-required="true" :disabled="!isPrimaryUser" />
                            <span v-show="errors.has('pa.paName') && pa.paName.length === 0" class="has-error">PA Name
                                is required</span>
                            <span v-show="errors.has('pa.paName') && pa.paName.length > 255" class="has-error">PA Name
                                cannot be longer than 255 characters</span>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-2 control-label">Responsible Federal Agency</label>
                        <div class="col-md-9">
                            <select v-model="selectedAgencyId" name="agencyId" class="form-control"
                                :disabled="!isPrimaryUser">
                                <option disabled value="">Select a value</option>
                                <option v-for="blm in agencyOrgList" :key="blm.id" :value="blm.id">{{ blm.description}}
                                </option>
                            </select>
                            <span
                                v-show="selectedLeadAgency && selectedLeadAgency.hasUsers === false && !selectedLeadAgency.agencyNoReview"
                                class="has-error">
                                Selected Federal Agency has no Wyotrack users
                            </span>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-2 control-label">Secondary Federal Agencies</label>
                        <div class="col-md-9">
                            <v-select v-model="secondaryAgencyOrgs" :options="agencyOrgList" name="secondaryAgencyIds"
                                label="description" style="background-color: #fafafa" multiple
                                :disabled="!isPrimaryUser" />
                        </div>
                    </div>
                    <div class="form-group" v-bind:class="{ 'has-error': errors.has('pa.agencyNo') }">
                        <label class="col-md-2 control-label">Agency Number</label>
                        <div class="col-md-9">
                            <input v-model="pa.agencyNo" v-validate="'max:255'" class="form-control" type="text"
                                name="agencyNo" :disabled="!isPrimaryUser" />
                            <span v-show="errors.has('pa.agencyNo')" class="has-error">Agency Number cannot be longer
                                than 255 characters</span>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-2 control-label">Effective Date</label>
                        <div class="col-md-6">
                            <el-date-picker v-model="pa.effectiveDate" type="date" format="MM/dd/yyyy"
                                placeholder="Select Effective Date" :disabled="!isPrimaryUser && !isSecondaryUser" />
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-2 control-label">Stipulations</label>
                        <div class="col-md-9">
                            <button v-on:click="createNewStipulation()" class="btn btn-primary" type="button"
                                name="addStipulation" :disabled="!pa.paId || (!isPrimaryUser && !isSecondaryUser)" v-if="!isUnknownUser"
                            >Add Stipulation</button>
                            <v-client-table :data="stipGridSpec.tableData" :columns="stipGridSpec.columns"
                                :options="stipGridSpec.options" ref="stipulationTable">
                                <template slot="edit" slot-scope="props" >
                                    <div style="text-align: center;" v-if="!isUnknownUser">
                                        <a class="fa fa-edit" style="font-size: 18px;"
                                            v-on:click="$refs['stipulation' + props.index][0].open()"></a>
                                    </div>
                                </template>
                            </v-client-table>
                            <modal v-for="(stipulation, index) in pa.paStipulationList" :key="index"
                                :ref="'stipulation' + index">
                                <div slot="header" class="">
                                    <h3 class="pull-left">Stipulation</h3>
                                </div>
                                <div slot="body">
                                    <div class="">
                                        <form class="form form-horizontal" @submit.prevent data-vv-scope="stipulation">
                                            <div class="form-group"
                                                v-bind:class="{ 'has-error': errors.has('stipulation.stipHeading') }">
                                                <label class="col-xs-3 control-label">Stipulation Heading</label>
                                                <div class="col-xs-9">
                                                    <input class="form-control" type="text" name="stipHeading"
                                                        v-model="stipulation.stipulationHeading" v-validate="'required'"
                                                        aria-required="true"></input>
                                                    <span v-show="errors.has('stipulation.stipHeading')"
                                                        class="has-error">Stipulation Heading is required</span>
                                                </div>
                                            </div>
                                            <div class="form-group"
                                                v-bind:class="{ 'has-error': errors.has('stipulation.stipDescription') }">
                                                <label class="col-xs-3 control-label">Stipulation Description</label>
                                                <div class="col-xs-9">
                                                    <textarea class="form-control" name="stipDescription" rows="5"
                                                        v-model="stipulation.stipulationDescription"
                                                        v-validate="'required'" aria-required="true"></textarea>
                                                    <span v-show="errors.has('stipulation.stipDescription')"
                                                        class="has-error">Stipulation Description is required</span>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label class="col-xs-3 control-label">Has Due Date</label>
                                                <div class="col-xs-6">
                                                    <div class="checkbox">
                                                        <input :id="'dueDate' + index" type="checkbox" name="hasDueDate"
                                                            v-model="stipulation.hasDueDate"></input>
                                                        <label :for="'dueDate' + index"></label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="stipulation.hasDueDate" class="form-group">
                                                <label class="col-xs-3 control-label">Due Date</label>
                                                <div class="col-xs-6">
                                                    <el-date-picker v-model="stipulation.dueDate" type="date"
                                                        format="MM/dd/yyyy"
                                                        placeholder="Select Due Date"></el-date-picker>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label class="col-xs-3 control-label">Complete Date</label>
                                                <div class="col-xs-6">
                                                    <el-date-picker v-model="stipulation.completeDate" type="date"
                                                        format="MM/dd/yyyy"
                                                        placeholder="Select Complete Date"></el-date-picker>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                <div slot="footer">
                                    <div class="">
                                        <button class="btn btn-primary col-xs-5" type="button" name="close"
                                            v-on:click="validateStipulation(index)">Finish Editing and Close</button>
                                    </div>
                                </div>
                            </modal>
                            <modal ref="newStipulationModal">
                                <div slot="header" class="">
                                    <h3 class="pull-left">Stipulation</h3>
                                    <button class="btn pull-right"
                                        v-on:click="$refs['newStipulationModal'].close()">X</button>
                                </div>
                                <div slot="body">
                                    <div class="">
                                        <form class="form form-horizontal" @submit.prevent
                                            data-vv-scope="stipulationNew">
                                            <div class="form-group"
                                                v-bind:class="{ 'has-error': errors.has('stipulationNew.stipHeading') }">
                                                <label class="col-xs-3 control-label">Stipulation Heading</label>
                                                <div class="col-xs-9">
                                                    <input class="form-control" type="text" name="stipHeading"
                                                        v-model="newStipulation.stipulationHeading"
                                                        v-validate="'required'" aria-required="true"></input>
                                                    <span v-show="errors.has('stipulationNew.stipHeading')"
                                                        class="has-error">Stipulation Heading is required</span>
                                                </div>
                                            </div>
                                            <div class="form-group"
                                                v-bind:class="{ 'has-error': errors.has('stipulationNew.stipDescription') }">
                                                <label class="col-xs-3 control-label">Stipulation Description</label>
                                                <div class="col-xs-9">
                                                    <textarea class="form-control" type="text" name="stipDescription"
                                                        rows="5" v-model="newStipulation.stipulationDescription"
                                                        v-validate="'required'" aria-required="true"></textarea>
                                                    <span v-show="errors.has('stipulationNew.stipDescription')"
                                                        class="has-error">Stipulation Description is required</span>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label class="col-xs-3 control-label">Has Due Date</label>
                                                <div class="col-xs-6">
                                                    <div class="checkbox">
                                                        <input id="hasDueDateNew" type="checkbox" name="hasDueDate"
                                                            v-model="newStipulation.hasDueDate">
                                                        <label for="hasDueDateNew"></label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="newStipulation.hasDueDate" class="form-group">
                                                <label class="col-xs-3 control-label">Due Date</label>
                                                <div class="col-xs-6">
                                                    <el-date-picker v-model="newStipulation.dueDate" type="date"
                                                        format="MM/dd/yyyy"
                                                        placeholder="Select Due Date"></el-date-picker>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label class="col-xs-3 control-label">Complete Date</label>
                                                <div class="col-xs-6">
                                                    <el-date-picker v-model="newStipulation.completeDate" type="date"
                                                        format="MM/dd/yyyy"
                                                        placeholder="Select Complete Date"></el-date-picker>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                <div slot="footer">
                                    <div class="">
                                        <button class="btn btn-primary col-xs-5" type="button" name="close"
                                            v-on:click="saveNewStipulation">Finish Creating and Close</button>
                                    </div>
                                </div>
                            </modal>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-2 control-label">Undertaking</label>
                        <div class="col-md-9">
                            <button v-on:click="$refs['undertakingAssignModal'].open()" class="btn btn-primary"
                                type="button" name="assignUndertaking" v-if="!isUnknownUser"
                                :disabled="!pa.paId || (!isPrimaryUser && !isSecondaryUser)">Assign Undertaking</button>
                            <v-client-table :data="utGridSpec.tableData" :columns="utGridSpec.columns"
                                :options="utGridSpec.options" ref="undertakingTable">
                                <template slot="edit" slot-scope="props" v-if="!isUnknownUser">
                                    <div style="text-align: center;">
                                        <!-- <a class="fa fa-edit" style="font-size: 18px;" v-on:click="editUndertakingRow(props.row.undertakingId)"></a> -->
                                        <router-link :to="{ path: '/Undertaking/' + props.row.undertakingId }" tag="a"
                                            class="fa fa-edit" style="font-size: 16px;"></router-link>
                                    </div>
                                </template>
                                <template slot="remove" slot-scope="props" v-if="!isUnknownUser">
                                    <div style="text-align: center;">
                                        <button class="btn"
                                            v-on:click="removeUndertaking(props.row.undertakingId)">Remove</button>
                                    </div>
                                </template>
                            </v-client-table>
                            <modal ref="undertakingAssignModal">
                                <div slot="header" class="">
                                    <h3 class="pull-left">Assign Undertaking</h3>
                                    <button class="btn pull-right"
                                        v-on:click="$refs['undertakingAssignModal'].close()">X</button>
                                </div>
                                <div slot="body">
                                    <h4>Search Undertaking</h4>
                                    <div class="">
                                        <form @submit.prevent="loadData" class="form-horizontal">
                                            <div class="form-group">
                                                <div class="col-sm-2">
                                                    <label for="searchDbNumber">DB Number</label>
                                                </div>
                                                <div class="col-sm-2">
                                                    <input class="form-control" type="text" name="searchDbNumber"
                                                        v-model="utSearchDto.dbNumber">
                                                </div>
                                                <div class="col-sm-2 col-sm-offset-1">
                                                    <label for="searchName">Name</label>
                                                </div>
                                                <div class="col-sm-5">
                                                    <input class="form-control" type="text" name="searchName"
                                                        v-model="utSearchDto.name">
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <div class="col-md-2">
                                                    <label for="searchAgnecyNo">Agency Number</label>
                                                </div>
                                                <div class="col-md-4">
                                                    <input class="form-control" type="text" name="searchAgnecyNo"
                                                        v-model="utSearchDto.agencyNumber">
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <div class="col-md-2">
                                                    <button class="btn btn-primary" type="submit" name="button"
                                                        v-on:click="loadUnassignedUndertakings()">Search</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                    <div class="">
                                        <v-client-table :data="utAllGridSpec.tableData" :columns="utAllGridSpec.columns"
                                            :options="utAllGridSpec.options">
                                            <template slot="assign" slot-scope="props">
                                                <div style="text-align: center;">
                                                    <button class="btn"
                                                        v-on:click="assignUndertaking(props.row.undertakingId)">Assign</button>
                                                </div>
                                            </template>
                                        </v-client-table>
                                    </div>
                                </div>
                                <div slot="footer">
                                    <div class="">
                                        <button class="btn btn-primary col-md-3" type="button" name="cancel"
                                            v-on:click="$refs['undertakingAssignModal'].close()">Close</button>
                                    </div>
                                </div>
                            </modal>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-2 control-label">&nbsp;</label>
                        <div class="col-md-4">
                            <validationResultDisplay :validationResult="validationResult"></validationResultDisplay>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-offset-2" v-if="!isUnknownUser">
                            <hr />
                            <button class="btn btn-primary" type="submit" name="submit" style="width:100px;" v-on:click="savePa">
                                {{paId ? 'Save' : 'Create'}}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </tab>
        <tab header="Documents">
            <moaPaDocuments v-if="$route.params.paId" :paId="$route.params.paId" :loadOnMount="false" ref="paDocuments">
            </moaPaDocuments>
            <div style="margin-top: 20px;">
                <hr />
                <mediaLetter :mediaTypeId="mediaTypeIdPaLetter" :parentId="paId" :loadOnMount="false" ref="mediaLetter">
                </mediaLetter>
            </div>
        </tab>
        <tab header="Workflow" v-if="$route.params.paId && isPrimaryUser" :disabled="!$route.params.paId || !isPrimaryUser">
            <div style="margin-top: 20px;">
                <workflow :workflowId="paWorkflowId" :parentId="paId" ref="workflow"
                    v-on:workflowOnSubmitSuccess="workflowOnSubmitSuccess" />
            </div>
            <div v-if="checkShpoRole" style="margin-top: 20px;">
                <quickLetter :paId="paId" :mediaTypeId="mediaTypeIdPaLetter" :parentId="paId"></quickLetter>
            </div>
        </tab>
    </tabs>
</template>

<script>
    import loggingService from '../services/util/loggingService'
    import paService from '../services/paService'
    import dateService from '../services/util/dateService'
    import undertakingService from '@/services/undertakingService'
    import organizationService from '@/services/organizationService'
    import workflowService from '../services/workflowService'
    import mediaService from '../services/mediaService'
    import roleService from '../services/roleService.js'
    import userService from '@/services/userService.js'
    import { mapState } from 'vuex'

    import loader from '@/components/Loader.vue'
    import modal from '@/components/Modal.vue'
    import { tab, tabs } from 'vue-strap'
    import workflow from '../components/Workflow.vue'
    import mediaLetter from '../components/MediaLetter.vue'
    import quickLetter from '../components/QuickLetter.vue'
    import moaPaDocuments from '../components/MoaPaDocuments.vue'
    import validationResultDisplay from '@/components/ValidationResultDisplay.vue'

    export default {
        components: {
            loader,
            modal,
            tabs,
            tab,
            workflow,
            moaPaDocuments,
            mediaLetter,
            quickLetter,
            validationResultDisplay
        },
        data: function () {
            return {
                isDebug: false,
                loading: true,
                activeTabIndex: 0,
                pa: {},
                agencyOrgList: [],
                secondaryAgencyOrgs: [], // as agencyOrgList item []
                newStipulation: {},
                stipGridSpec: {
                    columns: ['edit', 'stipulationHeading', 'dueDateDisplay', 'completeDateDisplay'],
                    options: {
                        dateFormat: 'YYYY-MM-DD',
                        perPage: 10,
                        perPageValues: [5, 10, 25, 50, 100],
                        dateColumns: ['dueDate', 'completeDate'],
                        headings: {
                            stipulationHeading: 'Stipulation',
                            dueDateDisplay: 'Due Date',
                            completeDateDisplay: 'Complete Date'
                        }
                    },
                    tableData: []
                },
                utGridSpec: {
                    columns: ['edit', 'dbNumber', 'name', 'agencyDescription', 'agencyUndertakingNo', 'effect', 'createdDate', 'remove'],
                    options: {
                        dateFormat: 'YYYY-MM-DD',
                        perPage: 10,
                        perPageValues: [10, 25, 50, 100],
                        dateColumns: ['createdDate'],
                        headings: {
                            name: 'Name',
                            dbNumber: 'DB Number',
                            agencyDescription: 'Agency',
                            agencyUndertakingNo: 'Agency No',
                            effect: 'Finding of Effect',
                            createdDate: 'Created Date'
                        },
                        orderBy: {
                            ascending: false,
                            column: 'reportdDate'
                        },
                        filterable: false
                    },
                    tableData: []
                },
                utAllGridSpec: {
                    columns: ['assign', 'dbNumber', 'name', 'agencyDescription', 'agencyUndertakingNo', 'effect', 'createdDate'],
                    tableData: [],
                    options: {
                        dateFormat: 'YYYY-MM-DD',
                        perPage: 5,
                        perPageValues: [5, 10, 25, 50, 100],
                        dateColumns: ['createdDate'],
                        headings: {
                            name: 'Name',
                            dbNumber: 'DB Number',
                            agencyDescription: 'Agency',
                            agencyUndertakingNo: 'Agency No',
                            effect: 'Finding of Effect',
                            createdDate: 'Created Date'
                        },
                        orderBy: {
                            ascending: false,
                            column: 'reportdDate'
                        }
                    }
                },
                utSearchDto: {
                    dbNumber: '',
                    name: '',
                    agencyNumber: ''
                },
                tabsEnum: {
                    moa: 0,
                    documents: 1,
                    workflow: 2,
                    workflowLoaded: false
                },
                validationResult: { messages: [] },
                selectedAgencyId: null,
                primaryAgencyOrgList: [] //not implemented yet. Use if we need to restrict Resp. Federal Agency List
            }
        },
        watch: {
            activeTabIndex: function (val) {
                loggingService.log(this.isDebug, 'Pa', 'watch.activeTabIndex: ' + val)
                switch (val) {
                case this.tabsEnum.pa:
                    break
                case this.tabsEnum.documents:
                    this.$refs.moaDocuments.loadMedia()
                    this.$refs.mediaLetter.loadMedia()
                    break
                case this.tabsEnum.workflow: //Workflow
                    if (!this.tabsEnum.workflowLoaded) {
                        this.$refs.workflow.loadData()
                        loggingService.log(this.isDebug, 'Pa', 'watch.activeTabIndex: ' + val + ', called: workflow.loadData')
                    }
                    this.tabsEnum.workflowLoaded = true
                    break
                }
            }
        },
        computed: {
            paId: function () {
                return this.$route.params.paId
            },
            paWorkflowId: function () {
                return workflowService.WorkflowEnum.Pa
            },
            mediaTypeIdPaLetter: function () {
                return mediaService.mediaType.PaLetter
            },
            // compute current user info
            ...mapState({
                shpoUserDto: state => state.auth.shpoUserDto
            }),
            checkShpoRole: function () {
                return (this.shpoUserDto && userService.hasRoleCheck(this.shpoUserDto.roleList, roleService.ShpoRoleList))
            },
            selectedLeadAgency: function () {
                return this.agencyOrgList.find(o => o.id === this.selectedAgencyId)
            },
            isUnknownUser: function () {
                return !this.isPrimaryUser && !this.isSecondaryUser
            },
            isSecondaryUser: function () {
                // if the user is not the primary user and in the secondary organizations
                return !this.isPrimaryUser && this.shpoUserDto.userOrganizationList &&
                    this.shpoUserDto.userOrganizationList
                        .map(o => o.organizationId)
                        .some(o => this.pa.secondaryAgencyIds.includes(o))
            },
            isPrimaryUser: function () {
                // if the user is an administrator or in the main organization
                return !this.paId || userService.hasRoleCheck(this.shpoUserDto.roleList, roleService.ShpoRoleList) ||
                    this.shpoUserDto.userOrganizationList
                        .map(o => o.organizationId)
                        .includes(this.pa.agencyId)
            }
        },
        mounted () {
            loggingService.log(this.isDebug, 'Undertakings', 'mounted')
            Promise.all([
                this.loadData(),
                this.loadUnassignedUndertakings(),
                this.loadAgencyList()
            ]).then(_response => {
                this.secondaryAgencyOrgs = this.agencyOrgList.filter(aol => (this.pa.secondaryAgencyIds || []).includes(aol.id))
                //add selected agency if it's not in primary
                if (!this.primaryAgencyOrgList.includes(this.selectedAgencyId)) {
                    this.primaryAgencyOrgList.push(this.agencyOrgList.find(a => a.id === this.selectedAgencyId))
                }
                this.loading = false
            })
        },
        methods: {
            throwException () {
                paService.throwException(this.$http)
            },
            async loadData () {
                return new Promise((resolve, reject) => {
                    loggingService.log(this.isDebug, 'PA', `loading data pa:${this.$route.params.paId}`)
                    if (this.$route.params.paId) {
                        paService.get(this.$http, this.$route.params.paId).then(response => {
                            loggingService.log(this.isDebug, 'PA', 'paService.get.then')
                            this.pa = response.data
                            this.selectedAgencyId = this.pa.agencyId
                            if (this.pa.paStipulationList) {
                                this.createStipDateDisplay()
                                this.stipGridSpec.tableData = this.pa.paStipulationList
                            }
                            if (this.pa.undertakingList) {
                                this.pa.undertakingList.forEach(ut => {
                                    ut.createdDate = dateService.convertToDate(ut.createdDate)
                                })
                                this.utGridSpec.tableData = this.pa.undertakingList
                            }
                            return resolve()
                        }).catch(err => {
                            return reject(err)
                        })
                    } else {
                        loggingService.log(this.isDebug, 'Undertaking', 'new pa')
                        this.createNewPa()
                        return resolve()
                    }
                })
            },
            async loadUnassignedUndertakings () {
                return new Promise((resolve, reject) => {
                    loggingService.log(this.isDebug, 'PA', 'loading unassignedUndertakings')
                    undertakingService.searchUnassigned(this.$http, this.utSearchDto).then(response => {
                        loggingService.log(this.isDebug, 'PA', 'undertakingService.searchUnassigned.then')
                        this.utAllGridSpec.tableData = response.data //.filter(x => x.reqPa)
                        return resolve()
                    }).catch(err => {
                        return reject(err)
                    })
                })
            },
            async loadAgencyList () {
                return new Promise((resolve, reject) => {
                    loggingService.log(this.isDebug, 'PA', 'loading BLM Organization List')
                    organizationService.listLeadAgencyLookup(this.$http).then(response => {
                        loggingService.log(this.isDebug, 'PA', 'organizationService.listLeadAgencyLookup.then')
                        this.agencyOrgList = response.data
                        //restrict primary agency list
                        if (!this.checkShpoRole) {
                            this.primaryAgencyOrgList = this.agencyOrgList.filter(
                                x => this.shpoUserDto.userOrganizationList.some(y => y.organizationId === x.id)
                            )
                        }
                        return resolve()
                    }).catch(err => {
                        return reject(err)
                    })
                })
            },
            createNewPa () {
                this.pa = {
                    paName: '',
                    agencyNo: '',
                    effectiveDate: null,
                    paStipulationList: [],
                    undertakingList: [],
                    secondaryAgencyIds: []
                }
            },
            createNewStipulation () {
                this.newStipulation = {
                    paId: this.pa.paId,
                    stipulationHeading: '',
                    stipulationDescription: '',
                    hasDueDate: false,
                    dueDate: null,
                    completeDate: null
                }
                this.$refs['newStipulationModal'].open()
            },
            saveNewStipulation () {
                this.$validator.validateAll('stipulationNew').then(result => {
                    if (result) {
                        loggingService.log(this.isDebug, 'Pa', 'saveNewStipulation - form validated and saved')
                        this.pa.paStipulationList.push(this.newStipulation)
                        this.createStipDateDisplay()
                        this.$refs.stipulationTable.refresh
                        this.$refs['newStipulationModal'].close()
                        this.newStipulation = {}
                    } else {
                        loggingService.log(this.isDebug, 'Pa', 'saveNewStipulation - invalid form')
                    }
                })
            },
            validateStipulation (index) {
                this.$validator.validateAll('stipulation').then(result => {
                    if (result) {
                        loggingService.log(this.isDebug, 'Pa', 'validateStipulation - valid form')
                        this.createStipDateDisplay()
                        this.$refs['stipulation' + index][0].close()
                    } else {
                        loggingService.log(this.isDebug, 'Pa', 'validateStipulation - invalid form')
                    }
                })
            },
            savePa () {
                this.$validator.validateAll('pa').then(result => {
                    if (result) {
                        var confirmMsg = 'There are more than one Undertakings assigned to this PA, continue to save?'
                        if (this.pa.undertakingList.length < 2 || confirm(confirmMsg)) {
                            this.validationResult = { messages: [] }
                            this.pa.agencyId = this.selectedAgencyId
                            this.pa.secondaryAgencyIds = this.secondaryAgencyOrgs.map(sao => sao.id)
                            this.loading = true
                            paService.put(this.$http, this.pa).then(response => {
                                // ensure the page goes to the correct pa id route after creating a new pa
                                if (response.data.objectList && response.data.objectList.length > 0) {
                                    this.$router.push('/Pa/' + response.data.objectList[0].paId)
                                    this.loadData()
                                } else {
                                    this.validationResult = response.data
                                }
                                loggingService.log(this.isDebug, 'Pa', 'savePa - complete')
                                this.loading = false
                            })
                        }
                    } else {
                        loggingService.log(this.isDebug, 'Pa', 'savePa - invalid form')
                    }
                })
            },
            createStipDateDisplay () {
                this.pa.paStipulationList.forEach(row => {
                    row.dueDateDisplay = dateService.convertToDate(row.dueDate)
                    row.completeDateDisplay = dateService.convertToDate(row.completeDate)
                })
            },
            editUndertakingRow (id) {
                loggingService.log(this.isDebug, 'Pa', 'editRow, id: ' + id)
                this.$router.push('/Undertaking/' + id)
            },
            assignUndertaking (id) {
                if (confirm('Are you sure you want to assign this Undertaking to the PA?')) {
                    // create the setPa object
                    var setPa = {
                        paId: this.pa.paId,
                        undertakingId: id
                        //oldUndertakingId: this.pa.undertakingList.length > 0 ? this.pa.undertakingList[0].undertakingId : null
                    }
                    // Assign new undertaking
                    undertakingService.setPa(this.$http, setPa).then(response => {
                        loggingService.log(this.isDebug, 'Pa', 'new undertaking assigned to PA')
                        Promise.all([this.loadData(), this.loadUnassignedUndertakings()])
                        this.$refs['undertakingAssignModal'].close()
                    })
                }
            },
            removeUndertaking (id) {
                if (confirm('Are you sure you want to remove this Undertaking from the PA?')) {
                    // create the setPa object
                    var setPa = {
                        paId: null,
                        undertakingId: id
                    }
                    // remove PA assignment
                    undertakingService.setPa(this.$http, setPa).then(response => {
                        loggingService.log(this.isDebug, 'Pa', 'undertaking removed from PA')
                        this.loadData()
                    })
                }
            },
            workflowOnSubmitSuccess (submitValidationResult) {
                //trigger media letter refresh if letter gen is triggered
                if (submitValidationResult.letterGenTriggered && this.$refs.mediaLetter) {
                    this.$refs.mediaLetter.autoRefreshMedia()
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// Pa.vue?2b14dc4a